import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../Reveal";

export default function AboutUs() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-5%", "5%"]);
  const bgScale = useTransform(scrollYProgress, [0, 0.5, 1], [1.06, 1.0, 1.06]);

  return (
    <section
      ref={ref}
      id="guest"
      data-testid="about-section"
      className="relative bg-white py-32 md:py-48 px-6 md:px-12 overflow-hidden"
    >
      {/* Full-screen logo watermark (same treatment as hero) */}
      <motion.div
        style={{ y: bgY, scale: bgScale }}
        className="absolute inset-0 pointer-events-none"
      >
        <img
          src="/jay-ink-logo.png"
          alt=""
          aria-hidden
          draggable={false}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-none object-cover select-none"
          style={{
            width: "max(100vw, 100vh)",
            height: "max(100vw, 100vh)",
            opacity: 1,
          }}
        />
      </motion.div>
      {/* Soft white veil for text legibility */}
      <div className="absolute inset-0 bg-white/70 pointer-events-none" />

      <div className="relative z-10 max-w-[1200px] mx-auto text-center">
        <Reveal>
          <h2
            className="font-display text-[#0A0A0A] uppercase mx-auto mb-16 md:mb-20"
            style={{
              fontSize: "clamp(2.4rem, 8vw, 7rem)",
              letterSpacing: "0.28em",
              paddingLeft: "0.28em",
              fontWeight: 200,
              lineHeight: 1,
            }}
          >
            ABOUT&nbsp;US
          </h2>
        </Reveal>

        <div className="mx-auto max-w-[860px] space-y-8 md:space-y-10 text-[#333] text-base md:text-lg font-light leading-[1.9]">
          <Reveal delay={0.1}>
            <p
              className="uppercase text-[#0A0A0A] text-lg md:text-2xl"
              style={{
                fontFamily: "'Jost', 'Futura', sans-serif",
                letterSpacing: "0.42em",
                paddingLeft: "0.42em",
                fontWeight: 300,
              }}
            >
              JAY-INK&nbsp;ACADEMY
            </p>
          </Reveal>

          <Reveal delay={0.18}>
            <p>
              Welcome to{" "}
              <span
                className="uppercase text-[#0A0A0A]"
                style={{
                  fontFamily: "'Jost', 'Futura', sans-serif",
                  letterSpacing: "0.3em",
                  fontWeight: 300,
                }}
              >
                JAY-INK&nbsp;ACADEMY
              </span>
              , Sydney&rsquo;s home to the best Micro Realism and Fine Line Tattoo
              Artists.
            </p>
          </Reveal>

          <Reveal delay={0.24}>
            <p>
              <span
                className="uppercase text-[#0A0A0A]"
                style={{
                  fontFamily: "'Jost', 'Futura', sans-serif",
                  letterSpacing: "0.3em",
                  fontWeight: 300,
                }}
              >
                JAY-INK&nbsp;ACADEMY
              </span>{" "}
              is proud to introduce a new era of tattoo culture to Sydney,
              Australia. Where the country&rsquo;s best come together to form an
              elite team of artists specialised in Micro Realism and Fine Line
              Contemporary Art.
            </p>
          </Reveal>

          <Reveal delay={0.3}>
            <p>
              Our mission is to create a community of artists providing endless
              creativity, cultural connection, in a place of learning and
              inspiration — elevating the quality of tattooing to its highest
              artistic form…
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
